import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";

const AdminContext = createContext();

export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const auth = getAuth();


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
        const userUid = auth.currentUser?.uid;
        if (userUid) {
            getDoc(doc(db, 'users', userUid)).then((userDoc) => {
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setIsAdmin(userData.isAdmin || false);
                }
            }).catch((error) => {
                console.error('Error fetching user data:', error);
            });
        }
        });
        return () => unsubscribe();
    }, [auth]);


    return (
        <AdminContext.Provider value={{ isAdmin, setIsAdmin }}>
            {children}
        </AdminContext.Provider>
    );
};
